import { Eye, Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { IngredientRowViewModel } from "../types/ingredientListView.types";

interface IngredientRowActionsProps {
  row: IngredientRowViewModel;
  onView: (row: IngredientRowViewModel) => void;
  onEdit: (row: IngredientRowViewModel) => void;
  onDelete: (row: IngredientRowViewModel) => void;
}

const actionButtonClass = "tw-h-8 tw-w-8";

/**
 * View / edit / delete icon actions for one grid row, built on the common
 * `Button` (ghost/icon variant) the same way row actions are built in the
 * Recipe Simulator table
 * (src/screens/recipe_simulator/newList/components/RecipeListTableRow.tsx).
 *
 * Only rendered when the row has a supplier assigned — same `hideEditCol`
 * rule the legacy grid applies (see
 * src/screens/ingredients/ingredientList/IngredientList.tsx).
 */
const IngredientRowActions = ({ row, onView, onEdit, onDelete }: IngredientRowActionsProps) => {
  if (!row.supplier_name) {
    return null;
  }

  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="View"
        onClick={() => onView(row)}
      >
        <Eye className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="Edit"
        onClick={() => onEdit(row)}
      >
        <Pencil className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={`${actionButtonClass} tw-text-destructive hover:tw-text-destructive`}
        title="Delete"
        onClick={() => onDelete(row)}
      >
        <Trash2 className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  );
};

export default IngredientRowActions;
